import { useState } from 'react'

export enum LoadState {
  Initial = 0,
  Loading = 1,
  Success = 2,
  Error = 3
}

export const useLoadState =
  (initialState = LoadState.Initial) => {
    const [loadState, setLoadState] = useState(initialState)

    return {
      loadState,
      setInitial: () => setLoadState(LoadState.Initial),
      setLoading: () => setLoadState(LoadState.Loading),
      setSuccess: () => setLoadState(LoadState.Success),
      setError: () => setLoadState(LoadState.Error)
    } as const
  }